module.exports = __webpack_public_path__ + "static/img/more_heard2.d233f618.png";